import React, { useEffect, useState } from "react";
import RadioGroup from "../../components/Form/RadioGroup";
import Search from "../../components/Form/Search";
import Button from "../../components/Form/Button";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Modal from "../../components/Elements/Modal";
import FunFactsItem from "../../components/Items/FunFactsItem";
import AddFunFacts from "../../components/Modals/AddFunFacts";
import Pagination from "../../components/Elements/Pagination";
import {
  funFactsList,
  ordering
} from "../../helpers/api_helper";
import moment from "moment/moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Confirm from "../../components/Elements/Confirm";
import Select from "react-select";
import { NoData } from "../../components/Elements/NoData";
import { Loading } from "../../components/Elements/Loading";
import { Error } from "../../components/Elements/Error";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

const FunFacts = () => {
  const [isAddModal, setIsAddModal] = useState(false);
  const [radioData, setRadioData] = useState(1);
  const [list, setList] = useState();
  const [editItemId, setEditItemId] = useState("");
  const [editModel, setEditModel] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [isOne, setDataOne] = useState(false);
  const [selectedPageOpt, setSelectedPageOpt] = useState([]);
  const [perPages, setPerPages] = useState([
    { label: "10 (Default)", value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
    { label: "All", value: 99999999 },
  ]);

  const showToastMessage = (data) => {
    if (data.status === 200) {
      setIsAddModal(false);
      toast.success(data.message);
    } else {
      toast.error(data.message);
    }
  };

  const queryClient = useQueryClient();

    useEffect(()=>{
      setOffset(0)
      setLimit(10)
   
    },[keyword,radioData])

  const funFactsKey = ["fanFacts,", keyword, radioData, limit, offset];
  function FunFactsList() {
    function useFanFact() {
      return useQuery({
        queryKey: funFactsKey,
        queryFn: () =>
          funFactsList({
            keyword: keyword,
            sortByField: "ordering",
            sortByValue: 1,
            status: radioData === 1 ? "" : radioData === 2 ? true : false,
            limit: limit,
            offset: offset,
          }),
        keepPreviousData: true,
      });
    }

    const { data: listData, error, isFetching } = useFanFact();

    useEffect(() => {
      if(!isOne){
      setList(listData?.data);
      }
    }, [isOne,listData?.data]);

 



    const handleDragEnd = (e) => {
      //console.log(e);
      if (!e.destination) return;
      let tempData = Array.from(list);
      let [source_data] = tempData.splice(e.source.index, 1);
      tempData.splice(e.destination.index, 0, source_data);

      setList([...tempData]);
      let dataArray = [];
      for (let i = 0; i < tempData.length; i++) {
        dataArray.push({ id: tempData[i]._id, ordering: i + 1 });
      }

      onClickSaveOrdering(dataArray);
      setDataOne(true);
    };

    const onClickSaveOrdering = async (orderingData) => {
      const saveOrdering = await ordering({
        orderingData: orderingData,
        tableName: "funFacts",
      });

      if (saveOrdering.status === 200) {
        setDataOne(false);
        queryClient.invalidateQueries(funFactsKey);
        queryClient.removeQueries({
          queryKey: ["futureTeam"],
          type: "inactive",
        });
        toast.success(saveOrdering.message);
      } else {
        toast.error(saveOrdering.message);
      }
    };

    if (isFetching) {
      return <Loading />;
    } else if (error) {
      return <Error />;
    } else if (listData?.data?.length === 0) {
      return <NoData />;
    } else {
      return (
        <>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {Array.isArray(list) &&
                    list.map((item,index) => (
                      <FunFactsItem
                        key={item._id}
                        title={item.title}
                        index={index}
                        id={item._id}
                        description={item.description}
                        createdBy={item.createdBy}
                        createdDate={moment(new Date(item?.created_at)).format(
                          "Do MMM YY"
                        )}
                        updatedDate={moment(new Date(item?.updated_at)).format(
                          "Do MMM YY"
                        )}
                        status={item.status === false ? 3 : 1}
                        isDraft={item.status}
                        editId={handelEdit}
                        setEditModel={setEditModel}
                      />
                    ))}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          <Pagination
            count={listData?.count}
            limit={limit}
            offset={offset}
            setOffset={setOffset}
          />
        </>
      );
    }
  }

  const handelReload = () => {
    queryClient.invalidateQueries(funFactsKey);
    queryClient.removeQueries({
      queryKey: ["fanFacts"],
      type: "inactive",
    });

    setKeyword("");
    setOffset(0);
    setLimit(10);
    setRadioData(1);
    setSelectedPageOpt([]);
  };

  const addModal = () => {
    setIsAddModal(true);
  };

  const handelEdit = (id) => {
    setEditItemId(id);
  };

  const status = [
    { _id: 1, name: "All", color: "success", current: true },
    { _id: 2, name: "Published", color: "success", current: false },
    { _id: 3, name: "Draft", color: "warning", current: false },
  ];

  return (
    <>
      <div className="page-filter mb-3">
        <div className="input-filters">
          <div className="input-items">
            <div className="input">
              <Select
                className="select-tag"
                isMulti={false}
                isClearable={true}
                options={perPages}
                value={selectedPageOpt || []}
                placeholder={"Per Page"}
                onChange={(e) => {
                  setLimit(e.value);
                  setSelectedPageOpt(e);
                }}
              />
            </div>
          </div>
          <div className="input-items">
            <Search
              placeholder={"Search..."}
              setState={setKeyword}
              state={keyword}
            />
          </div>

          <div className="input-items items-end gap-3 ms-auto">
            <Button
              classes={"px-2"}
              icon={"fa-regular fa-arrow-rotate-right"}
              iconPosition={"left"}
              functions={handelReload}
            />
            <Button
              label={"Add"}
              icon={"fa-regular fa-plus"}
              iconPosition={"left"}
              functions={addModal}
            />
          </div>
        </div>
        <div className="input-items">
          <RadioGroup
            data={status}
            inputName={"status"}
            setData={setRadioData}
          />
        </div>
      </div>
      <div className="funfacts-list">
        <FunFactsList></FunFactsList>
      </div>

      <Modal
        title={"Add"}
        size={"md"}
        isOpen={isAddModal}
        modalClose={() => setIsAddModal(!isAddModal)}
      >
        <AddFunFacts
          setIsAddModal={setIsAddModal}
          showToastMessage={showToastMessage}
          query={funFactsKey}
        />
      </Modal>

      <Modal
        title={"Edit "}
        size={"md"}
        isOpen={editModel}
        modalClose={() => setEditModel(false)}
      >
        <AddFunFacts
          setEditModel={setEditModel}
          isOpen={editModel}
          showToastMessage={showToastMessage}
          itemId={editItemId}
          editMode={true}
        />
      </Modal>
    </>
  );
};

export default FunFacts;
